import Stack from "@mui/material/Stack";
import { PostsFeedTitle } from "../GroupDetailsPage/Group.styles";
import { PostsListFacade } from "../GroupDetailsPage/Facades/PostsListFacade";
import React, { useEffect, useRef } from "react";
import { useGlobalConfigs } from "@infrastructure/Hooks/useGlobalConfigs";
import {
    PostDetailsModal,
    PostDetailsPageActions,
} from "../../Components/Modals/PostDetailsModal/PostDetailsModal";
import { usePostCardClickHandler } from "../GroupDetailsPage/Hooks/usePostCardClickHandler";
import { usePortalReference } from "@infrastructure/Persistence/PortalReferenceStore";
import { Box } from "@mui/system";
import {
    GroupInput,
    WRAPPER_ACTIONS_ENUM,
    WrapperParams,
} from "@shared/Types/GroupEntry.types";
import { usePostDetailsModalStore } from "../../Components/Modals/PostDetailsModal/PostDetailsModalStore";
import { useUserProfileStore } from "@infrastructure/Persistence/UserProfileState";
import { useUserUuid } from "@infrastructure/Hooks/UserInteractions/useUserId";
import { TippspielCommunityIcon } from "@icons/TippspielCommunityIcon";
import { LogoSubtitle } from "./PostFeed.styles";
import { useGroupSelector } from "../../Components/GroupSelector/useGroupSelector";
import { ActiveGamesIndicator } from "../../Components/ActiveGamesIndicator/ActiveGamesIndicator";
import { PostListFacade } from "../../Components/EntryFeedModal/PostListFacade";

const groupData: GroupInput = {
    id: "1", // random id just to have it for now
    title: "Tippspiel Community",
    showAvatar: false,
};

export function PostsListFeedEntryComponent({
    params,
    isDashboardFeed = false,
    userAvatar,
    userScreenName,
}: {
    params: URLSearchParams;
    isDashboardFeed?: boolean;
    userAvatar?: string;
    userScreenName?: string;
}) {
    const { getConfigs } = useGlobalConfigs();
    const tippspielFeedEnabled = getConfigs()?.tippspielFeedEnabled;
    const onPostCardClick = usePostCardClickHandler(isDashboardFeed);
    const portalRef = useRef<HTMLDivElement>();
    const { setIsPostDetailsModalOpen, setPostDetailsAction } =
        usePostDetailsModalStore();
    const { setPortalRef } = usePortalReference();
    const { storedUserId } = useUserUuid();
    useEffect(() => {
        setPortalRef(portalRef);
    }, [portalRef]);

    const { setUserProfile } = useUserProfileStore();
    useEffect(() => {
        setUserProfile({
            uuid: storedUserId ?? "",
            avatar: userAvatar ?? "",
            screenName: userScreenName ?? "",
            privacySettings: {
                showProfilePicture: undefined,
            },
        });
    }, []);

    useEffect(() => {
        if (!tippspielFeedEnabled) {
            setIsPostDetailsModalOpen(false);
            return;
        }

        const getParam = (name: string): string | null => {
            const param = params.get(name);
            if (param) {
                const newurl =
                    window.location.protocol +
                    "//" +
                    window.location.host +
                    window.location.pathname;
                // replacing state to avoid page rerender
                window.history.replaceState({ path: newurl }, "", newurl);
            }
            return param;
        };

        const paramsToPass: WrapperParams = {
            action: getParam("action"),
            postId: getParam("postId") ?? undefined,
            commentId: getParam("commentId") ?? undefined,
        };
        if (!paramsToPass?.action) {
            return;
        }

        if (
            paramsToPass.action === WRAPPER_ACTIONS_ENUM.OPEN_POST_DETAILS &&
            paramsToPass?.postId
        ) {
            setIsPostDetailsModalOpen(true, parseInt(paramsToPass.postId));
        } else if (
            paramsToPass?.action === WRAPPER_ACTIONS_ENUM.OPEN_POST_COMMENT &&
            paramsToPass?.postId
        ) {
            setPostDetailsAction({
                desiredAction: PostDetailsPageActions.PIN_COMMENT,
                commentId: paramsToPass.commentId,
            });
            setIsPostDetailsModalOpen(true, parseInt(paramsToPass.postId));
        }
    }, [tippspielFeedEnabled]);

    const { filters } = useGroupSelector();

    if (!tippspielFeedEnabled) {
        return null;
    }

    return (
        <>
            <Stack
                component={"div"}
                width={"100%"}
                sx={{
                    backgroundColor: isDashboardFeed ? "inherit" : "#efeff4",
                }}
            >
                <div id={"portal"} ref={portalRef}></div>
                {isDashboardFeed ? (
                    <PostsFeedTitle
                        padding={isDashboardFeed ? "0 16px" : "0 12px"}
                    >
                        <TippspielCommunityIcon
                            height={"28px"}
                            width={"auto"}
                        />
                        <LogoSubtitle>
                            Kommentiere, vote und teile Deine Highlights
                        </LogoSubtitle>
                    </PostsFeedTitle>
                ) : (
                    <Box sx={{ marginTop: "16px" }} />
                )}
                <ActiveGamesIndicator />
                {filters?.length && (
                    <Box padding={isDashboardFeed ? "0 16px" : "0 12px"}>
                        <PostsListFacade
                            onPostCardClick={onPostCardClick}
                            isDashboardFeed={isDashboardFeed}
                            postContainerRef={portalRef}
                        />
                    </Box>
                )}
                <PostDetailsModal insidePresenter={!isDashboardFeed} />
            </Stack>
            <PostListFacade groupData={groupData} />
        </>
    );
}
